import { render } from "./TuitionPriceLists.vue?vue&type=template&id=7cdd0ffa&ts=true"
import script from "./TuitionPriceLists.vue?vue&type=script&lang=ts"
export * from "./TuitionPriceLists.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__